import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  if (hasFilters) {
    return (
      <div className="bg-surface border border-border rounded-md p-12 text-center">
        <div className="max-w-md mx-auto">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-gray-100 rounded-full">
              <Icon name="Search" size={24} className="text-text-secondary" />
            </div>
          </div>
          <h3 className="text-lg font-medium text-text-primary mb-2">
            No Results Found
          </h3>
          <p className="text-text-secondary mb-6">
            We couldn't find any validation sessions matching your current filters. 
            Try adjusting your search criteria or clearing the filters.
          </p>
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear All Filters
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-border rounded-md p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-primary/10 rounded-full">
            <Icon name="Clock" size={24} className="text-primary" />
          </div>
        </div>
        <h3 className="text-lg font-medium text-text-primary mb-2">
          No Validation History
        </h3>
        <p className="text-text-secondary mb-6">
          You haven't performed any email validations yet. Start validating emails 
          to see your history and track your validation activities.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            as={Link}
                            to="/"
            variant="primary"
            iconName="Mail"
            iconPosition="left"
          >
            Validate Single Email
          </Button>
          <Button
            as={Link}
            to="/bulk-email-validation"
            variant="outline"
            iconName="FileText"
            iconPosition="left"
          >
            Bulk Validation
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;